// =============================================
// VISOR DE IMÁGENES
// Modal para ver comprobantes
// =============================================

import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Alert,
} from '@mui/material';

const ImageViewer = ({ open, onClose, imageUrl }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleImageLoad = () => {
    setLoading(false);
    setError(false);
  };

  const handleImageError = () => {
    setLoading(false);
    setError(true);
  };

  // Reset states cuando cambia la URL
  React.useEffect(() => {
    if (imageUrl) {
      console.log('ImageViewer - URL recibida:', imageUrl);
      setLoading(true);
      setError(false);
    }
  }, [imageUrl]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 400,
          }}
        >
          {!imageUrl ? (
            <Alert severity="info">No hay imagen disponible</Alert>
          ) : error ? (
            <Box sx={{ textAlign: 'center' }}>
              <Alert severity="error" sx={{ mb: 2 }}>
                Error al cargar la imagen
              </Alert>
              <Button variant="outlined" onClick={() => window.open(imageUrl, '_blank')}>
                Intentar abrir en nueva pestaña
              </Button>
            </Box>
          ) : (
            <>
              {loading && (
                <Box sx={{ position: 'absolute' }}>
                  <CircularProgress />
                </Box>
              )}
              <img
                src={imageUrl}
                alt="Comprobante"
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{
                  maxWidth: '100%',
                  maxHeight: '70vh',
                  objectFit: 'contain',
                  display: loading ? 'none' : 'block',
                }}
              />
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
        {imageUrl && !error && (
          <Button
            variant="contained"
            onClick={() => window.open(imageUrl, '_blank')}
          >
            Abrir en nueva pestaña
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ImageViewer;
